module.exports = __webpack_public_path__ + "static/media/clinicbanner.15fafb08.png";